import * as React from 'react';
import CreatorOnBoardingContainer from '../creatorOnBoarding/creatorOnBoardingContainer';

export default function EditCreatorProfile() {
  return <CreatorOnBoardingContainer formMode='update' />;
}
